/**
 * Очистка HTML перед выводом через innerHTML (замена v-html для данных, которые вводят пользователи).
 *
 * Оставляет только теги форматирования из белого списка, удаляет все обработчики событий (on*),
 * style и ссылки со схемами кроме http(s), mailto, tel и относительных.
 * Теги не из списка заменяются своим текстовым содержимым.
 */

const ALLOWED_TAGS = [
    'a', 'b', 'br', 'div', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'li', 'ol', 'p',
    's', 'small', 'span', 'strong', 'sub', 'sup', 'table', 'tbody', 'td', 'th', 'thead', 'tr', 'u', 'ul',
];

const ALLOWED_ATTRIBUTES = ['class', 'href', 'target', 'rel', 'title', 'colspan', 'rowspan'];

const SAFE_URL = /^(https?:|mailto:|tel:|\/|#|\.\/|\.\.\/|[^:]*$)/i;

function cleanNode(node) {
    Array.from(node.childNodes).forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
            return;
        }

        if (child.nodeType !== Node.ELEMENT_NODE) {
            child.remove();
            return;
        }

        const tag = child.tagName.toLowerCase();

        if (!ALLOWED_TAGS.includes(tag)) {
            // script/style и прочие теги не выводятся; содержимое неизвестных тегов остаётся текстом
            if (tag === 'script' || tag === 'style') {
                child.remove();
            } else {
                child.replaceWith(document.createTextNode(child.textContent));
            }
            return;
        }

        Array.from(child.attributes).forEach((attribute) => {
            const name = attribute.name.toLowerCase();
            const value = attribute.value.trim();

            if (!ALLOWED_ATTRIBUTES.includes(name) || (name === 'href' && !SAFE_URL.test(value))) {
                child.removeAttribute(attribute.name);
            }
        });

        if (tag === 'a' && child.getAttribute('target') === '_blank') {
            child.setAttribute('rel', 'noopener noreferrer');
        }

        cleanNode(child);
    });
}

/**
 * Возвращает безопасный HTML.
 *
 * @param html {*} Исходная строка
 * @returns {string}
 */
export default function safeHtml(html) {
    if (html === null || html === undefined || html === '') {
        return '';
    }

    // DOMParser создаёт инертный документ: скрипты и обработчики при разборе не выполняются
    const doc = new DOMParser().parseFromString(String(html), 'text/html');

    cleanNode(doc.body);

    return doc.body.innerHTML;
}

/**
 * Директива v-safe-html: как v-html, но с очисткой содержимого.
 * Хуки для Vue 2 (bind/update) и Vue 3 (mounted/updated).
 */
export const safeHtmlDirective = {
    bind(el, binding) {
        el.innerHTML = safeHtml(binding.value);
    },
    update(el, binding) {
        el.innerHTML = safeHtml(binding.value);
    },
    mounted(el, binding) {
        el.innerHTML = safeHtml(binding.value);
    },
    updated(el, binding) {
        el.innerHTML = safeHtml(binding.value);
    },
};
